import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { getProducts, getSchemes, useConfig } from '../../state/configuration'
import { AppPath } from '../AppPath'
import { PrefillPage } from './PrefillPage'

export const PrefillRouter: FunctionComponent = () => {
  const schemes = useConfig(getSchemes)
  const products = useConfig(getProducts)

  return (
    <Routes>
      {schemes.map((scheme) => {
        const product = products[scheme.schemeCode]

        return product?.prefill ? (
          <Route
            key={scheme.productUrlName}
            path={scheme.productUrlName}
            element={<PrefillPage scheme={scheme} prefill={product.prefill} />}
          />
        ) : null
      })}

      <Route path='*' element={<Navigate to={AppPath.HOME} />} />
    </Routes>
  )
}
